import styled from 'styled-components';
import addAlpha from 'utils/addAlpha';
import { Overline } from 'components/Typography';
import DefaultButton from 'components/Buttons/AddButton';
import DefaultModifier from './Modifier';

// TODO: TFR-44 move to container group or do not export
export const Container = styled.div`
  background-color: ${({ theme }) => theme.colors.white};
  box-shadow:
    0rem 0.5rem 1rem rgba(35, 35, 35, 0.02),
    0rem 0.5rem 2rem rgba(35, 35, 35, 0.02);
  border-radius: 1.5rem;
  padding: 0.25rem;
  margin-bottom: 2rem;
`;

// TODO: TFR-45:Header make unique name or do not export
export const Header = styled.header`
  display: grid;
  align-items: center;
  grid-template-columns: 1.3fr 1fr 1fr 10rem 20rem;
  height: 3rem;
  padding: 0 2rem;
`;

// TODO: TFR-44 move to modifyer
export const Modifier = styled(DefaultModifier)`
  display: grid;
  grid-template-columns: 1.3fr 1fr 1fr 10rem 20rem;
  align-items: center;
  height: 4.5rem;
  padding: 0.25rem 2rem;
  border-radius: 1.25rem;

  :hover {
    cursor: pointer;
    background-color: ${({ theme }) => theme.colors.gray1};
  }
`;

// TODO: TFR-44 move to typography group
export const Caption = styled(Overline)`
  color: ${({ theme }) => addAlpha(theme.colors.navyGreen, 0.6)};
  letter-spacing: 0.1em;
  font-weight: 600;
`;

// TODO: TFR-44 move to container group
export const Footer = styled.div`
  height: 4.5rem;
  padding: 0 2rem;
  display: flex;
  align-items: center;
`;

// TODO: TFR-46 remove imports in styled.ts if you do not add styles to component
export const Button = styled(DefaultButton)``;
